/* eslint-disable react/prop-types */
/* eslint-disable react/jsx-filename-extension */
import React from 'react';

import Fade from 'react-reveal/Fade';

export default function Advantage({ data }) {
  return (
    <div className="bg-gray-50 py-24 mb-24 sm:mb-18 xl:mb-16">
      <div className="container mx-auto">
        <Fade bottom>
          <h1 className="text-5xl lg:text-6xl text-theme-blue text-center font-bold mb-16">Why Choose Us?</h1>
        </Fade>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 px-4">
          {
                        [...data[0], ...data[1]].map((item, index) => (
                          <Fade bottom delay={300 * index} key={item.title}>
                            <div className="group">
                              <div className="relative bg-white flex flex-row items-start p-6 rounded-2xl shadow-md border border-gray-100 transform transition-all duration-300 hover:scale-[1.02] hover:shadow-xl hover:border-theme-purple/20 h-full overflow-hidden">
                                {/* Decorative gradient overlay on hover */}
                                <div className="absolute inset-0 bg-gradient-to-br from-theme-purple/5 to-dark-theme-purple/5 opacity-0 group-hover:opacity-100 transition-opacity duration-300" />

                                <div className="relative flex-shrink-0 w-20 h-20 bg-gradient-to-br from-theme-purple/10 to-dark-theme-purple/10 rounded-xl flex items-center justify-center group-hover:from-theme-purple/20 group-hover:to-dark-theme-purple/20 transition-all duration-300">
                                  <img src={item.imageUrl} alt={item.title} className="w-12 h-12 object-contain transform transition-transform duration-300 group-hover:scale-110" />
                                  {/* Decorative ring */}
                                  <div className="absolute inset-0 rounded-xl border-2 border-theme-purple/20 opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                                </div>
                                <div className="relative flex-col pl-6 flex-grow z-10">
                                  <h2 className="text-theme-blue text-xl font-semibold mb-2 group-hover:text-theme-purple transition-colors duration-300">{item.title}</h2>
                                  <p className="font-light text-gray-600 text-sm leading-relaxed">{item.description}</p>
                                </div>

                                {/* Corner decoration */}
                                <div className="absolute top-0 right-0 w-16 h-16 bg-gradient-to-br from-theme-purple/5 to-transparent rounded-bl-full opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                              </div>
                            </div>
                          </Fade>
                        ))
                    }
        </div>
      </div>
    </div>
  );
}
